// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unternehmen/unsere-partner-und-mitgliedschaften/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unternehmenUnserePartnerUndMitgliedschaftenDE: PageEntry = {
  id: "post.unternehmen-unsere-partner-und-mitgliedschaften",
  locale: "de",
  slug: "unternehmen/unsere-partner-und-mitgliedschaften",
  seo: {
    navLabel: "Partner & Mitgliedschaften",
    title: "Partner von Dietz Federn",
    description: "Partner von Dietz Federn",
  },
  type: "post",
  h1: "Partner von Dietz Federn",
  blocks: [
    { kind: "image", src: "/images/live/dietz_aussen-1200x375.jpg", alt: "Firmengebäude Dietz", width: 1200, height: 375 },
    { kind: "heading", level: 2, text: "Unsere Partner und Mitgliedschaften" },
    { kind: "paragraph", text: "Zur hohen Qualität unserer Produkte und Leistungen tragen wesentlich unsere Partner bei:" },
    { kind: "logos", items: [
      { src: "/images/partners/TU-IL.png", alt: "Technische Universität Ilmenau FG Maschinenelemente", href: "https://www.tu-ilmenau.de/maschinenelemente/" },
      { src: "/images/partners/Hochschule-Kempten.jpg", alt: "Hochschule Kempten mit dem Forschungszentrum Allgäu", href: "http://www.hochschule-kempten.de/home.html" },
      { src: "/images/partners/Steinbeis_01_9e1e371907.jpg", alt: "Steinbeis-Transferzentrum Federntechnik Fakultät für Maschinenbau", href: "https://www.steinbeis.de/de.html" },
      { src: "/images/partners/IFU.jpg", alt: "Institut für Umformtechnik Lüdenscheid", href: "http://www.ifu-lued.de/" },
      { src: "/images/partners/2022-03-03-logo-klimaschutz-unternehmen-data-300x200.jpg", alt: "Klimaschutz-Unternehmen e.V.", href: "https://www.klimaschutz-unternehmen.de/startseite/" },
      { src: "/images/partners/VDFI.jpg", alt: "Verband der Deutschen Federnindustrie e. V.", href: "https://federnverband.de/" },
      { src: "/images/partners/knf-logo-neu-rgb.jpg", alt: "Das Fachnetzwerk der Kunststoffbranche", href: "https://www.kunststoff-netzwerk-franken.de/" },
      { src: "/images/partners/ofracar.jpg", alt: "OfraCar - Automobilnetzwerk e. V.", href: "http://www.ofracar.de/" },
      { src: "/images/partners/unk-gruendungsmitglied-220117-1.png", alt: "Unternehmensnetzwerk Klimaschutz", href: "http://unternehmensnetzwerk-klimaschutz.de/" },
      { src: "/images/partners/Mitglieder-Logo.png", alt: "VEA-Initiative Klimafreundlicher Mittelstand", href: "https://www.klimafreundlicher-mittelstand.de/" },
      { src: "/images/partners/csm_IHK_Logo_1551352070_ba4338695a-300x211.jpg", alt: "IHK zu Coburg", href: "https://www.ihk.de/coburg/" },
    ] },
  ],
};
